export default __webpack_public_path__ + "static/media/benefit-sec.21b43d01.svg";